<template>
  <div>
    <router-link to="/customers">View your customers</router-link>
    <a-card style="margin: 20px 0;" :bordered="false" class="needColumn">
      <a-avatar :src="`${API_URL}${customer.logo}`" size="large"/>
      <div>
        Give Points to customer {{customer.first_name}} {{customer.last_name}}
      </div>
    </a-card>
    <a-card style="margin: 20px 0;" title="Points Log" :bordered="false">
      <a-table :columns="columns"
               :dataSource="pointsLog"
               :pagination="{ pageSize: 10 }"
               rowKey="updated_at"
               :scroll="{ y: 700 }">
        <span slot="remove" slot-scope="text,record">
          <a-button @click="showRemoveModal(record)"
                    type="primary">
            Remove
          </a-button>
        </span>
        <span slot="isSystem"
              slot-scope="text,record"
              v-if="record.is_system === true">
            SYSTEM
        </span>
        <span slot="isSystem"
              slot-scope="text,record"
              v-else>
            {{record.agent_name}}
        </span>
        <span slot="trigger"
              slot-scope="text,record"
              v-if="record.is_system === true">
            QR-ID
        </span>
        <span slot="trigger"
              slot-scope="text,record"
              v-else>
            Manual
        </span>
        <span slot="updated_at"
              slot-scope="text,record">
            {{moment(record.updated_at).format('D-MMM YYYY @ h:mma')}}
        </span>
      </a-table>
      <div style="display: flex;justify-content: center;align-items: center">
        <a-input-number :min="10"
                        :step="10"
                        :max="100"
                        :value="issuedPoint"
                        @change="pointChange"
        />
        <a-button style="margin: 50px;display: flex;"
                  type="primary"
                  @click="showModal">
          Give Points
        </a-button>
        <a-modal
          v-model="givePoint"
          onOk="handleOk"
        >
          <p>Issue {{this.issuedPoint}} Points to current customer?</p>
          <template slot="footer">
            <a-button key="back" @click="handleCancel">Cancel</a-button>
            <a-button key="submit" type="primary" @click="handleOk">
              Give points
            </a-button>
          </template>
        </a-modal>
        <a-modal
          v-model="removePoint"
          onOk="handleOk"
        >
          <p>Remove points from current customer?</p>
          <template slot="footer">
            <a-button key="back" @click="handleCancel">Cancel</a-button>
            <a-button key="submit" type="primary" @click="removeButton">
              Remove points
            </a-button>
          </template>
        </a-modal>
      </div>
    </a-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {API_URL} from '../../constants'
import moment from 'moment'

const columns = [{
  title: 'Member Name',
  dataIndex: 'name',
  width: 250,
}, {
  title: 'Reward Name',
  dataIndex: 'reward',
  width: 120,
}, {
  title: 'Points Issued',
  dataIndex: 'count',
  width: 250,
}, {
  title: 'Trigger',
  dataIndex: 'purchase_progress',
  scopedSlots: { customRender: 'trigger' },

  width: 100,
}, {
  title: 'Staff Name or System',
  dataIndex: 'is_system',
  scopedSlots: { customRender: 'isSystem' },
  width: 150,
}, {
  title: 'Updated',
  dataIndex: 'updated_at',
  width: 150,
  scopedSlots: { customRender: 'updated_at' },
}, {
  title: 'Remove',
  dataIndex: 'rewardsManage',
  width: 150,
  scopedSlots: { customRender: 'remove' },
} ]

export default {
  name: 'GivePoints',
  data () {
    return {
      columns,
      API_URL,
      givePoint: false,
      removePoint: false,
    }
  },
  mounted () {
    this.$store.dispatch('loyalty/getPointsLog', this.$route.params.user_id)
  },
  methods: {
    moment,
    navigate (name, params) {
      this.$router.push({name, params})
    },
    pointChange (value) {
      this.$store.commit('loyalty/onChangeIssuedPoint', value)
    },
    givePoints () {
      this.$store.dispatch('loyalty/givePoints', this.$route.params.user_id)
    },
    removeButton () {
      this.$store.dispatch('loyalty/removePoints', this.$route.params.user_id)
      this.removePoint = false
    },
    showModal () {
      this.givePoint = true
    },
    showRemoveModal (removedPoint) {
      this.$store.commit('loyalty/onChangeRemovePoint', removedPoint.count)
      this.removePoint = true
    },
    handleOk () {
      this.$store.dispatch('loyalty/givePoints', this.$route.params.user_id)
      this.givePoint = false
    },
    handleCancel () {
      this.givePoint = false
      this.removePoint = false
    },
  },
  computed: {
    ...mapState({
      pointsLog: state => {
        return state.loyalty.points.map(point => ({
          id: point.id,
          count: `${point.count}0`,
          is_system: point.is_system,
          agent_name: point.agent && point.agent.name,
          name: `${point.user.first_name} ${point.user.last_name}`,
          updated_at: point.created_at,
          reward: point.offer && point.offer.name,
        }))
      },
      user: state => state.auth.user,
      customer: state => state.loyalty.customer,
      issuedPoint: state => state.loyalty.issuedPoint,
      removePointCount: state => state.loyalty.removePointCount,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
</style>



// WEBPACK FOOTER //
// src/components/Customers/GivePoints.vue